import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon, Input } from "semantic-ui-react";
import { loginRequest } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { RedirectIfLoggedIn } from "./RedirectIfLoggedIn";
import { ReactComponent as Logo } from "../../icons/Logo text_vertical.svg";
import { ReactComponent as BMIMILogo } from "../../icons/BMIMI_Logo_srgb.svg";
import { ReactComponent as LogoText } from "../../icons/Logo_text.svg";
import { ReactComponent as MiniLogo } from "../../icons/Logo_compass.svg";
import { LanguageSelector } from "../../components/LanguageSelector/LanguageSelector";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { AutoLogoutModal } from "./AutoLogoutModal";
import "./Login.css";

export const Login = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const history = useHistory();
    const loginState = useSelector((state: AppState) => state.login);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const disabled = username.length === 0 || password.length === 0 || loginState.currentlySending;

    const handleKeyPress = (e: any) =>
        !disabled && (e.key === "Enter" || e.charCode === 13)
            ? dispatch(loginRequest({ username, password }))
            : null;

    return (
        <div className="login-container">
            <RedirectIfLoggedIn />
            <div className="login-wrapper">
                <div className="center-login-container">
                    <section className="left-container">
                        <div className="upper-container">
                            <MiniLogo id="mini-logo" />
                        </div>
                        <div className="lower-container">
                            <LogoText id="logo-text" />
                        </div>
                        <Logo title="" id="logo" />
                    </section>
                    <section className="login-form-container">
                        {loginState.isEnabled ? (
                            <>
                                <Input
                                    id="username"
                                    placeholder={intl.formatMessage({ id: "username" })}
                                    value={username}
                                    onChange={(e: any) => setUsername(e.target.value)}
                                    onKeyPress={(e: any) => handleKeyPress(e)}
                                />
                                <Input
                                    id="password"
                                    type="password"
                                    placeholder={intl.formatMessage({ id: "password" })}
                                    value={password}
                                    onChange={(e: any) => setPassword(e.target.value)}
                                    onKeyPress={(e: any) => handleKeyPress(e)}
                                />
                                <div className="login-options">
                                    <LanguageSelector />
                                    <label
                                        id="cursor"
                                        onClick={() => history.push("/forgot-password")}
                                    >
                                        <Icon name="lock" />
                                        {intl.formatMessage({ id: "forgotPassword" })}
                                    </label>
                                </div>
                                <p id="login-error-message">
                                    {!!loginState.error?.message &&
                                        intl.formatMessage({ id: "invalidCredentials" })}
                                </p>
                                <hr />
                                <Button
                                    id="login-button"
                                    fluid
                                    primary
                                    loading={loginState.currentlySending}
                                    disabled={disabled}
                                    onClick={() => {
                                        dispatch(loginRequest({ username, password }));
                                    }}
                                    content={intl.formatMessage({ id: "logIn" })}
                                />
                            </>
                        ) : (
                            <div id="login-locked-message">
                                <h4>{intl.formatMessage({ id: "yourAccountLocked" })}</h4>
                                <h4>{intl.formatMessage({ id: "followTheInstructions" })}</h4>
                            </div>
                        )}
                    </section>
                </div>
                <BMIMILogo title="" id="bmimi-logo" />
            </div>
            {localStorage.getItem("autoLogout") &&
                localStorage.getItem("autoLogout") === "true" && <AutoLogoutModal />}
        </div>
    );
};
